import script from "./deliverable.vue?vue&type=script&setup=true&lang=ts"
export * from "./deliverable.vue?vue&type=script&setup=true&lang=ts"

import "./deliverable.vue?vue&type=style&index=0&id=9f734166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f734166"]])

export default __exports__